import { forwardRef, type InputHTMLAttributes } from 'react';
import { LoaderCircle } from 'lucide-react';

import { inputStyle } from './input';

export type TextareaInputProps = InputHTMLAttributes<HTMLTextAreaElement> & {
  rows?: number;
  loading?: boolean;
  error?: boolean;
};

const TextareaInput = forwardRef<HTMLTextAreaElement, TextareaInputProps>(
  function (
    {
      loading = false,
      error = false,
      disabled = false,
      rows = 4,
      className,
      ...props
    },
    ref,
  ) {
    const style = textareaInputStyle({
      error,
      loading,
      disabled,
    });

    return (
      <div className={style.container()}>
        <textarea
          ref={ref}
          rows={rows}
          {...props}
          className={style.input({ className })}
          disabled={disabled || loading}
        />
        <div
          className={style.inputLoader({ className: 'top-4 translate-y-0' })}
        >
          <LoaderCircle className={style.inputLoaderIcon()} />
        </div>
      </div>
    );
  },
);

export const textareaInputStyle = inputStyle;

TextareaInput.displayName = 'TextareaInput';
export { TextareaInput };
